// Copyright (c) Microsoft Corporation. All rights reserved.
export var Device;
(function (Device) {
    Device.BrowserMap = {
        chrome: 'chrome',
        'microsoft edge': 'edge',
        safari: 'safari',
        firefox: 'firefox',
        tizen: 'chrome',
    };
    Device.OSMap = {
        macos: 'macOS',
        windows: 'windows',
        linux: 'linux',
        ios: 'iOS',
        android: 'android',
        'chrome os': 'chromeOS',
        tizen: 'tizen',
        fireos: 'fireOS',
    };
    Device.DeviceTypeMap = {
        desktop: 'desktop',
        mobile: 'mobile',
        tablet: 'tablet',
        smarttv: 'smarttv',
    };
})(Device || (Device = {}));
//# sourceMappingURL=Device.js.map